import React, { useId } from 'react';
import { getFieldHelp } from './adminHints';
import { humanize } from './consoleUtils';

export function FieldHelp({ resource = '', name, field, context, filter, id }) {
  const hint = getFieldHelp(resource, name, field, context, filter);
  return hint ? <span id={id} className="mt-1 block text-xs font-normal normal-case leading-4 tracking-normal text-slate-400">{hint}</span> : null;
}

// Help is visible, keyboard/touch friendly, and separate from the control's name.
// Attach descriptions to native controls inside compound inputs as well.
export function describeControls(children, id, label) {
  return React.Children.map(children, child => {
    if (!React.isValidElement(child)) return child;
    if (['input', 'select', 'textarea'].includes(child.type)) return React.cloneElement(child, {
      'aria-label': child.props['aria-label'] || label,
      'aria-describedby': [child.props['aria-describedby'], id].filter(Boolean).join(' ') || undefined,
    });
    if (typeof child.type === 'string' && child.props.children) return React.cloneElement(child, {}, describeControls(child.props.children, id, label));
    return child;
  });
}

export function HelpLabel({ resource = '', name, field, context, filter, label, children, ...props }) {
  const id = useId();
  const describedBy = getFieldHelp(resource, name, field, context, filter) ? id : undefined;
  const plainLabel = label || React.Children.toArray(children).filter(child => typeof child === 'string').join(' ').trim() || field?.attributes?.label || field?.label || humanize(name);
  return <label {...props}>{describeControls(children, describedBy, plainLabel)}<FieldHelp id={id} resource={resource} name={name} field={field} context={context} filter={filter} /></label>;
}

export function FieldLabel({ name, field, label }) {
  return <>{label || field?.attributes?.label || humanize(name)}</>;
}
